var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-placeholder"},[_c('fluent-icon',{attrs:{"icon":"document-error","size":"32"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('COMPONENTS.FILE_BUBBLE.INSTAGRAM_STORY_UNAVAILABLE')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }